/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { PostUserRes } from '../model/PostUserRes';
import { GetUserRes } from '../model/GetUserRes';
import { GetUserstateRes } from '../model/GetUserstateRes';
import { BaseRequestConfig } from '../../../framework/BaseRequestConfig';

export class UserApi {
    /**
     * Base Pathの設定。デフォルトは「/」
     */
    protected basePath: string = '/';

    /**
     * コンストラクタ
     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
     * @param { string } basePath ベースパスを設定する
     */
    constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: ng.IHttpParamSerializer, basePath?: string) {
        if (basePath) {
            this.basePath = basePath;
        }
    }

    /**
     * 認証
     * ユーザのログイン処理を行い、ログイン結果を取得する（ログイン成功：true, ログイン失敗：false）。また、ログイン成功時には合わせてユーザ情報を取得する
     * @param userid  ユーザID
     * @param password  パスワード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public userPost(
                userid: string,
                password: string,
                isDbl: boolean = false): ng.IHttpPromise<PostUserRes> {
        const path: string = this.basePath + '/user';

        let queryParameters: {[index: string]: any} = {};
        let formParams: {[index: string]: any} = {};
        let headerParams: {[index: string]: any} = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };

        formParams['userid'] = userid;
        formParams['password'] = password;

        let httpRequestParams: BaseRequestConfig = {
            method: 'POST',
            url: path,
            params: queryParameters,
            data: this.$httpParamSerializer(formParams),
            headers: headerParams,
            unique: isDbl,
            screenId: path
        };
        return this.$http(httpRequestParams);
    }

    /**
     * ユーザ情報取得
     * ユーザの情報を取得する
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public userGet(
                isDbl: boolean = false): ng.IHttpPromise<GetUserRes> {
        const path: string = this.basePath + '/user';

        let queryParameters: {[index: string]: any} = {};

        let httpRequestParams: BaseRequestConfig = {
            method: 'GET',
            url: path,
            params: queryParameters,
            unique: isDbl,
            screenId: path
        };
        return this.$http(httpRequestParams);
    }

    /**
     * 認証状態チェック
     * 認証状態をチェックする。認証されていればtrue, 認証されていなければ（セッションタイムアウト含む）falseを返す
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public userStateGet(
                isDbl: boolean = false): ng.IHttpPromise<GetUserstateRes> {
        const path: string = this.basePath + '/user/state';

        let queryParameters: {[index: string]: any} = {};

        let httpRequestParams: BaseRequestConfig = {
            method: 'GET',
            url: path,
            params: queryParameters,
            unique: isDbl,
            screenId: path
        };
        return this.$http(httpRequestParams);
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/authentication/api/UserApi.ts
 **/